import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { buttonName } from "../../../locales/en";
import Style from "./../../../assets/scss/custom.module.scss";
import { FaDownload, FaUpload, FaSpinner } from "react-icons/fa";

const AccessPageAction = ({
  subheading,
  alluser,
  allUserTitle,
  createuser,
  createUserTitle,
  deactivate,
  deactivateTitle,
  deleteuser,
  deleteUserTitle,
  email,
  emailTitle,
  showDownloadUpload,
  onDownload,
  isDownloading,
  onUploadClick,
  isUploading
}) => {
  const isAnyActionGiven =
    email ||
    alluser ||
    createuser ||
    deactivate ||
    deleteuser ||
    showDownloadUpload;
  return (
    <div className="row mb-2 mx-0">
      <div className="col-12 sales-page-title-wrap sub-heading-blog-wrap pb-2">
        <div className="row box-heading">
          <div
            className={`col-md-${isAnyActionGiven ? 4 : 12} d-flex flex-wrap align-items-center`}
          >
            <h2>{subheading}</h2>
          </div>
          {isAnyActionGiven && (
            <div className="col-md-8">
              <ul
                className={`${Style.searchOptionWrap} d-flex flex-wrap align-items-center justify-content-md-end`}
              >
                {showDownloadUpload && (
                  <>
                    <li className="my-1 mx-1">
                      <button
                        className="btn btn-primary d-flex align-items-center"
                        onClick={onDownload}
                        disabled={isDownloading}
                      >
                        {isDownloading ? (
                          <FaSpinner className="spin-load me-1" />
                        ) : (
                          <FaDownload className="me-1" />
                        )}
                        {buttonName?.download}
                      </button>
                    </li>
                    <li className="my-1 mx-1">
                      <button
                        className="btn btn-primary d-flex align-items-center"
                        onClick={onUploadClick}
                        disabled={isUploading}
                      >
                        {isUploading ? (
                          <FaSpinner className="spin-load me-1" />
                        ) : (
                          <FaUpload className="me-1" />
                        )}
                        {buttonName?.upload}
                      </button>
                    </li>
                  </>
                )}
                {email && (
                  <li className="my-1">
                    <Link to={email} className="btn btn-primary">
                      {emailTitle}
                    </Link>
                  </li>
                )}
                {alluser && (
                  <li className="my-1">
                    <Link to={alluser} className="btn btn-blue">
                      {allUserTitle}
                    </Link>
                  </li>
                )}
                {createuser && (
                  <li className="my-1">
                    <Link to={createuser} className="btn btn-primary">
                      {createUserTitle}
                    </Link>
                  </li>
                )}
                {deactivate && (
                  <li className="my-1">
                    <Link
                      to={deactivate}
                      className="btn btn-warning text-white"
                    >
                      {deactivateTitle}
                    </Link>
                  </li>
                )}
                {deleteuser && (
                  <li className="my-1">
                    <Link to={deleteuser} className="btn btn-danger">
                      {deleteUserTitle}
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
AccessPageAction.propTypes = {
  subheading: PropTypes.string,
  alluser: PropTypes.string,
  allUserTitle: PropTypes.string,
  createuser: PropTypes.string,
  createUserTitle: PropTypes.string,
  deactivate: PropTypes.string,
  deactivateTitle: PropTypes.string,
  deleteuser: PropTypes.string,
  deleteUserTitle: PropTypes.string,
  email: PropTypes.string,
  emailTitle: PropTypes.string,
  showDownloadUpload: PropTypes.bool,
  onDownload: PropTypes.func,
  isDownloading: PropTypes.bool,
  onUploadClick: PropTypes.func,
  isUploading: PropTypes.bool
};

export default AccessPageAction;
